/**
 * The single MUI theme for the app. Extracted from App.tsx (v55) so
 * the palette is built from the guarded `themeColors` constants in one
 * place and can be asserted in a unit test (theme.vitest.ts) — guarding
 * against the applied palette drifting from the AA-checked constants.
 */
import { createTheme } from "@mui/material/styles";
import {
  WARNING_MAIN,
  PRIMARY_MAIN,
  SECONDARY_MAIN,
  INFO_MAIN,
} from "./utils/themeColors";

export const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: PRIMARY_MAIN },
    secondary: { main: SECONDARY_MAIN },
    // v57 — darker info so `color="info"` Chips (Qbert LP-name pills)
    // clear WCAG 4.5:1 with white text (MUI's #0288d1 is only 3.86:1).
    info: { main: INFO_MAIN },
    // v51 — darker warning so outlined warning Buttons (Sign out,
    // Start Blank) clear WCAG 4.5:1 on white.
    warning: { main: WARNING_MAIN },
  },
  components: {
    // v52 — MUI auto-wraps every AccordionDetails in a `role="region"`
    // whose accessible name = the summary's `id` (undefined here),
    // producing multiple unnamed regions that trip axe `landmark-unique`.
    // These accordions are disclosure widgets, not page landmarks, so
    // demote the region wrapper to presentation app-wide.
    MuiAccordion: {
      defaultProps: {
        slotProps: { region: { role: "presentation" } },
      },
    },
  },
});
